import React from 'react';
import ReactECharts from 'echarts-for-react';
import { healthTrendData } from '../../data/mockData';

const HealthChart = () => {
  const options = {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(19, 19, 26, 0.9)',
      borderColor: '#272733',
      textStyle: { color: '#e2e8f0' },
      axisPointer: { type: 'cross', label: { backgroundColor: '#8b5cf6' } }
    },
    legend: {
      data: ['Avg Health Score', 'Churn Risk (%)'],
      textStyle: { color: '#94a3b8' },
      top: 0
    },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: healthTrendData.dates,
        axisLine: { lineStyle: { color: '#272733' } },
        axisLabel: { color: '#94a3b8' }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: 'Health',
        nameTextStyle: { color: '#94a3b8' },
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#272733', type: 'dashed' } },
        axisLabel: { color: '#94a3b8' }
      },
      {
        type: 'value',
        name: 'Risk',
        nameTextStyle: { color: '#94a3b8' },
        axisLine: { show: false },
        splitLine: { show: false },
        axisLabel: { color: '#94a3b8' }
      }
    ],
    series: [
      {
        name: 'Avg Health Score',
        type: 'line',
        smooth: true,
        itemStyle: { color: '#10b981' },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: 'rgba(16, 185, 129, 0.3)' }, { offset: 1, color: 'rgba(16, 185, 129, 0.01)' }]
          }
        },
        data: healthTrendData.avgHealth
      },
      {
        name: 'Churn Risk (%)',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        itemStyle: { color: '#f43f5e' },
        lineStyle: { width: 2, type: 'dashed' },
        data: healthTrendData.churnRisk
      }
    ]
  };

  return <ReactECharts option={options} style={{ height: '300px', width: '100%' }} />;
};

export default HealthChart;